import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { site } from "@/config/site";

export default function LegalPage({ label, title, updated, intro, sections, testId }) {
  return (
    <div data-testid={testId}>
      <PageHero testId={`${testId}-hero`} label={label} title={title} subtitle={intro} />
      <section className="border-t border-fs-border bg-fs-bg2 py-20 lg:py-28">
        <div className="fs-shell max-w-3xl">
          {updated && (
            <p className="mb-12 text-xs uppercase tracking-[0.2em] text-fs-muted/70">
              Last updated: {updated}
            </p>
          )}
          <div className="space-y-12">
            {sections.map((s, i) => (
              <Reveal key={s.heading} delay={i * 0.03}>
                <div>
                  <h2 className="font-serif text-2xl font-normal text-fs-ink">{s.heading}</h2>
                  <div className="mt-4 space-y-4">
                    {s.body.map((p, j) => (
                      <p key={j} className="text-sm leading-relaxed text-fs-muted">
                        {p}
                      </p>
                    ))}
                    {s.list && (
                      <ul className="mt-2 space-y-2">
                        {s.list.map((li) => (
                          <li key={li} className="flex items-start gap-3 text-sm text-fs-muted">
                            <span className="mt-2 h-1 w-1 shrink-0 rotate-45 bg-fs-gold/70" />
                            {li}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <div className="mt-16 border-t border-fs-border pt-8 text-sm text-fs-muted">
            <p className="font-medium text-fs-ink">{site.companyLegalName}</p>
            <p className="mt-1">{site.registeredOffice}</p>
            <p className="mt-1">CIN: {site.cin}</p>
            <p className="mt-1">
              Email:{" "}
              <a href={`mailto:${site.contactEmail}`} className="text-fs-gold hover:underline">
                {site.contactEmail}
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
